import { render, staticRenderFns } from "./DateDetails.vue?vue&type=template&id=6fe90e2c&scoped=true&"
import script from "./DateDetails.vue?vue&type=script&lang=js&"
export * from "./DateDetails.vue?vue&type=script&lang=js&"
import style0 from "./DateDetails.vue?vue&type=style&index=0&id=6fe90e2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe90e2c",
  null
  
)

export default component.exports